/*
class MobileSubMenu {
    constructor() {
        this.allPanels = document.querySelectorAll('.menu ul.sub-menu');
        this.menuItems = document.querySelectorAll('.menu > .menu-item-has-children > a');

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            this.setupMenu();
        }
    }

    setupMenu() {
        this.menuItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const currentItem = item.nextElementSibling;
                const currentTarget = item.parentElement;

                if (currentItem.clientHeight !== 0) {
                    currentItem.classList.toggle('sub-menu--open');
                } else {
                    this.allPanels.forEach(panel => panel.classList.remove('sub-menu--open'));
                    currentItem.classList.toggle('sub-menu--open');
                }

                document.querySelector('.menu').animate({ scrollTop: 0 }, 'fast');

                if (currentItem.clientHeight !== 0) {
                    currentItem.classList.toggle('sub-menu--open');
                } else {
                    this.allPanels.forEach(panel => panel.classList.remove('sub-menu--open'));
                    currentItem.classList.toggle('sub-menu--open');
                }

                document.querySelector('.menu').animate({ scrollTop: currentTarget.offsetTop - 70 }, '0');

                console.log(currentTarget);
            });
        });
    }
}

export default MobileSubMenu;
*/

class MobileSubMenu {
    constructor() {
        this.allPanels = document.querySelectorAll('.menu ul.sub-menu');
        this.menuItems = document.querySelectorAll('.menu > .menu-item-has-children > a');

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            this.setupMenu();
            this.setupMenuCloseOnClick();
        }
    }

    setupMenu() {
        this.menuItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const currentItem = item.nextElementSibling;
                const currentTarget = item.parentElement;

                if (currentItem.clientHeight !== 0) {
                    currentItem.classList.toggle('sub-menu--open');
                } else {
                    this.allPanels.forEach(panel => panel.classList.remove('sub-menu--open'));
                    currentItem.classList.toggle('sub-menu--open');
                }

                document.querySelector('.menu').animate({ scrollTop: 0 }, 'fast');

                if (currentItem.clientHeight !== 0) {
                    currentItem.classList.toggle('sub-menu--open');
                } else {
                    this.allPanels.forEach(panel => panel.classList.remove('sub-menu--open'));
                    currentItem.classList.toggle('sub-menu--open');
                }

                document.querySelector('.menu').animate({ scrollTop: currentTarget.offsetTop - 70 }, '0');

                console.log(currentTarget);
            });
        });
    }

    setupMenuCloseOnClick() {
        document.addEventListener('click', (event) => {
            const subMenu = document.querySelector('.sub-menu');
            const subMenuTrigger = document.querySelector('.menu-item-has-children > a');

            const isSubMenuClicked = subMenu.contains(event.target) || subMenuTrigger.contains(event.target);

            if (!isSubMenuClicked) {
                this.allPanels.forEach(panel => panel.classList.remove('sub-menu--open'));
            }
        });
    }
}

export default MobileSubMenu;
